import { render, staticRenderFns } from "./smd-full-checkbox-list.vue?vue&type=template&id=2c39782f&scoped=true&"
import script from "./smd-full-checkbox-list.vue?vue&type=script&lang=js&"
export * from "./smd-full-checkbox-list.vue?vue&type=script&lang=js&"
import style0 from "./smd-full-checkbox-list.vue?vue&type=style&index=0&id=2c39782f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c39782f",
  null
  
)

export default component.exports